var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('footer.contact_info'))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.$t('footer.business_info'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }